import { Resume } from '@/types/resume/v1'
import {
  Paragraph,
  SectionType,
  TextRun,
  HeadingLevel,
  ISectionOptions,
} from 'docx'

export default ({
  skills = [],
  categorizedSkills = [],
}: Resume.Schema): ISectionOptions => {
  const children = [
    new Paragraph({
      text: '\n',
    }),
    new Paragraph({
      text: 'Core Skills',
      heading: HeadingLevel.HEADING_2,
    }),
  ]

  if (categorizedSkills.length > 0) {
    children.push(
      new Paragraph({
        text: '\n',
      }),
      ...buildSkillCategory(categorizedSkills)
    )
  }

  if (skills.length > 0) {
    children.push(
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: skills.map(s => s.name).join(', '),
      })
    )
  }

  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children,
  }
}

const buildSkillCategory = (
  categories: Resume.SkillCategory[]
): Paragraph[] => {
  return categories.map(
    ({ name, skills }) =>
      new Paragraph({
        children: [
          new TextRun({
            text: (name || 'Category name') + ': ',
            bold: true,
          }),
          new TextRun({
            text: skills.map(s => s.name).join(', '),
          }),
        ],
      })
  )
}
